import styled from 'styled-components';
import { RightTogglePopover } from 'ui/popover';
import { pxToRem } from 'utils/convert';

const StyledList = styled.ul`
  padding-left: ${pxToRem(16)};
  margin-bottom: ${pxToRem(0)};
  margin-left: ${pxToRem(0)};
  list-style-type: disc;
  display: flex;
  flex-direction: column;
  gap: ${pxToRem(5)};
`;

export const CLONE_CAMPAIGNS_POPOVER = 'clone-campaigns-popover';
export const CLONE_CAMPAIGNS_WARNINGS = 'clone-campaigns-warnings';

export const titleWarningText = `Some items won't be copied to the destination project`;
export const warnings = [
  'Image files — Images will still work in your new campaigns, but the files will be stored in the original project.',
  'Snippets and catalog — If the snippet and catalog exist in the destination project, they will work in the copied campaigns.',
  `Experiments - You'll need to create new experiments for campaigns in the new journey.`,
];

export const CloneCampaignsPopover = () => {
  return (
    <RightTogglePopover
      popoverContentTitle={titleWarningText}
      popoverContentBody={
        <StyledList data-test={CLONE_CAMPAIGNS_POPOVER}>
          {warnings.map((x, i) => (
            <li data-test={CLONE_CAMPAIGNS_WARNINGS} key={`warnings-${i}`}>
              {x}
            </li>
          ))}
        </StyledList>
      }
      $isInModal
    />
  );
};
